import type { ReactNode } from "react";
import Link from "@/components/ui/Link";

interface CreatorLinkProps {
  /** From creatorPath(); null when the pack has no author to link to. */
  href: string | null;
  className?: string;
  children: ReactNode;
  tabIndex?: number;
  "aria-hidden"?: boolean;
}

/**
 * A pack author's name or avatar, linked to their profile at /u/<id>.
 *
 * Without an author it renders exactly what the call site rendered before the
 * link existed — the same <span> with the same classes, or the bare children —
 * so the visible text of the ~25k ranking pack pages and their cards stays
 * byte-identical either way.
 */
export function CreatorLink({ href, className, children, ...rest }: CreatorLinkProps) {
  if (!href) return className ? <span className={className}>{children}</span> : <>{children}</>;
  return (
    <Link href={href} className={className} {...rest}>
      {children}
    </Link>
  );
}
